// Startups Line Chart View
var $ = require('jquery');
var Marionette = require('backbone.marionette');
var _ = require('underscore');
var d3 = require('d3');
var template = require('./template.hbs');
var ChartView = require('../../../common/chart-view.js');

module.exports = ChartView.extend({
	template: template,
  className: 'line-chart',
	specs: {},
	scale: {},
	canvas: {},

	constructor: function(options){
		ChartView.apply(this, arguments);
		// this.create_tooltip();
		this.registerEvents();

		if(!this.options.constants){
			this.options.constants = {
				START_YEAR: 1980,
				END_YEAR: 2015
			};
		}
		return this;
	},

	onAttach: function(){
		// Workaround for chart-wrapper not working on ChartView initialize. Proven working on MapsView.
		this.$el.wrap($('<div class="chart-wrapper">'));
		this.draw();
	},

	onBeforeRender: function(){
		if( UCS.App.MapState.get('zoomed') === true ){
			this.collection = UCS.App.MapState.get('matchedModelsColl');
		}else{
			this.collection = UCS.App.MapState.get('collection_copy');
		}
	},


	registerEvents: function(){
		this.listenTo( UCS.App.MapState,'change:selection', this.update, this);
		this.listenTo( UCS.App.MapState,'change:zoomed', this.update, this);
	},

	update: function(){
		this.render();
	},


	draw: function(){
		var chart = this;
		// Workaround: re-define these two after re-adding the chart-wrapper since it didn't quite get it on ChartView init
		this.$chart_container = this.$el.parent();
		this.chart_container = this.$chart_container.get(0);
		this.$chart_container.attr('id', 'line-chart-container');

		this.$el.empty();
		this.get_dimensions();

		chart.processed_data = this.process_data();

		this.get_scales();
    this.create_axes();
    this.create_svg();
		this.create_groups();
    this.draw_line();
		this.draw_axes();
		this.create_tooltip();
    // this.bind_mouse_events();
    return this;
	},




	get_scales: function(){
		var chart = this;
		var scale = chart.scale;
		var data = chart.processed_data;

		// Years
		scale.x = d3.scale.linear()
			.range([0, chart.dimensions.width]);

		// Startups
		scale.y = d3.scale.linear()
		  .range([chart.dimensions.height, 0]);

		//set x and y scale values to map to the svg size
		scale.x.domain(d3.extent(data, function(d) { return d.year; }) );
		scale.y.domain(d3.extent(data, function(d) { return d.startupsToDate; }) );
	},

	create_axes: function(){
		var chart = this;
		var scale = chart.scale;

		chart.xAxis = d3.svg.axis()
			.scale(scale.x)
			.tickFormat(function(d) {
        return chart.formatNumber(d);
      })
			.orient("bottom");

		chart.yAxis = d3.svg.axis()
			.scale(scale.y)
			.orient("left")
			.ticks(4)
			.tickFormat(function(d) { return chart.formatInteger(d); })
			.tickSubdivide(0);
	},

	create_svg: function() {
		var chart = this;
		var scale = chart.scale;

		chart.canvas = d3.select(chart.el)
		  .append("svg")
	    .attr({
	      "width": chart.dimensions.wrapperWidth,
	      "height": chart.dimensions.wrapperHeight
	    });

	},

	create_groups: function() {
		var chart = this;
		var canvas = chart.canvas;
		var margin = chart.options.margin;

		chart.group = canvas.append("g") // Main group
	    .attr({
	      "class": "mainGroup",
	      transform: "translate("+ margin.left +","+ margin.top +")",
	      "width": chart.dimensions.width,
	      "height": chart.dimensions.height
	    });
	},



	draw_line: function(){
		var chart = this;
		var scale = chart.scale;
		var group = chart.group;
		var canvas = chart.canvas;

		var data = chart.processed_data;

		var line = d3.svg.line() // D3 Line path generator
			.x(function(d,i) { return scale.x(d.year); })
			.y(function(d,i) { return scale.y(d.startupsToDate); })
			//.interpolate("basis") // Smoothing
			;

		var path = group.selectAll("path")
			.data([data]) // Note the extra brackets. Passes data as whole single Array.
			.enter()
			.append("path")
				.attr({
					"d": line,
					"fill": "none",
					"stroke": "#1295D8",
					"stroke-width": 3
				});

		// Path Animation
		var totalLength = path.node().getTotalLength();
			path
				.attr("stroke-dasharray", totalLength + " " + totalLength)
				.attr("stroke-dashoffset", totalLength)
				.transition()
					.duration(1000)
					.ease("linear")
					.attr("stroke-dashoffset", 0);
			//
			// canvas.on("click", function(){
			// 	path
			// 		.transition()
			// 		.duration(1000)
			// 		.ease("linear")
			// 		.attr("stroke-dashoffset", totalLength);
			// });
	},

	draw_axes: function(){
		var chart = this;
		var xAxis = chart.xAxis;
		var yAxis = chart.yAxis;
		var group = chart.group;

		group.append("g")
    .attr("class", "axis")
    .attr("transform", "translate(0,"+ (chart.dimensions.height) +")")
    .call(xAxis);


	  group.append("g")
	    .attr("class", "axis")
	    .attr("transform", "translate(0,0)")
	    .call(yAxis);
	},

	process_data: function(){
		var chart = this;
		var data = chart.data;

		var startupTotalsOverTime = [];

		var START_YEAR = chart.options.constants.START_YEAR;
		var END_YEAR = chart.options.constants.END_YEAR;

		var reject_range = function(data, i){
			return function(data){ return data.fiscal_yr_credit > i; };
		};

		for(var i = END_YEAR; i>=START_YEAR; i--){
			var chain = _.chain(data).
				reject( reject_range(data,i) ).
				value();

			var total = chain.length;

			startupTotalsOverTime.push({year: i,startupsToDate: total});
		}

		startupTotalsOverTime = _.sortBy(startupTotalsOverTime, 'year');

		return startupTotalsOverTime;
	},


	create_tooltip: function() {
		var chart = this;
		var data = chart.processed_data;
		var svg = chart.canvas;
		var mainGroup = chart.group;
		var x = chart.scale.x;
		var y = chart.scale.y;
		var margin = chart.options.margin;
		var END_YEAR = chart.options.constants.END_YEAR;

		var totalStartups = _.max(data, function(d){ return d.startupsToDate; });

		var focus = mainGroup.append("g")
      .attr("class", "focus");

		var bisectDate = d3.bisector(function(d) { return d.year; }).left;

	  focus.append("circle")
			.attr("r",7);

		// Tooltip
	  // focus.append("rect")
		// 	.attr("x", "-20px")
		// 	.attr("y", "-30px");
		//
		// focus.append("text")
		// 	.attr({
		// 		y: "-15px",
		// 		"text-anchor": "middle"
		// 	});

		mainGroup.append("text")
			.attr({
				x: 50,
				y: 50,
				class: 'num-startups'
			})
			.text(totalStartups.startupsToDate);

		mainGroup.append("text")
			.attr({
				x: 50,
				y: 70,
				class: 'label-startups'
			})
			.text('as of ' + END_YEAR);
		mousemove(true);

		mainGroup.append("rect")
      .attr("class", "overlay")
      .attr({
				width: function(){
					if(chart.dimensions.width < 0){
						return 0;
					}else {
						return chart.dimensions.width;
					}
				}
			})
      .attr("height", chart.dimensions.height)
      .on("mouseover", function() { focus.style("display", null); })
      // .on("mouseout", function() { focus.style("display", "none"); })
      .on("mousemove", mousemove);

		function mousemove(initial) {
			var x0;
			if(initial){
				x0 = x.invert(chart.dimensions.width);
			}else{
				x0 = x.invert(d3.mouse(this)[0]);
			}

	    var i = bisectDate(data, x0, 1),
	        d0 = data[i - 1],
	        d1 = data[i],
	        d = x0 - d0.year > d1.year - x0 ? d1 : d0;

	    focus.attr("transform", "translate(" + x(d.year) + "," + y(d.startupsToDate) + ")");
	    // focus.select("text").text( d.startupsToDate );

			mainGroup.select(".num-startups").text( d.startupsToDate );
			mainGroup.select(".label-startups").text( 'as of ' + d.year );
	  }

	},
});
